import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { useI18n } from "@/i18n";
import { ThemeToggle, useTheme } from "@/context/theme";

export default function Home() {
  const { t, lang, setLang } = useI18n();
  const { theme } = useTheme();
  const logo = theme === "dark" ? "/logos/rapidpay-white.png" : "/logos/rapidpay-color.webp";
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <header className="flex items-center justify-between px-5 sm:px-10 h-16">
        <img src={logo} alt="RapidPay" className="h-7" data-testid="home-logo" />
        <div className="flex items-center gap-1">
          <ThemeToggle />
          <button data-testid="home-language-toggle" onClick={() => setLang(lang === "es" ? "en" : "es")} className="text-sm font-semibold px-4 py-2 min-h-[44px] rounded-full hover:bg-secondary transition-colors">
            {lang === "es" ? "EN" : "ES"}
          </button>
        </div>
      </header>
      <main className="flex-1 flex flex-col justify-center px-5 sm:px-10 max-w-3xl">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[hsl(122,87%,30%)] dark:text-primary mb-4">RapidPay v2</p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight">{t("home.tagline")}</h1>
        <p className="mt-5 text-base md:text-lg text-muted-foreground max-w-xl">{t("home.subtitle")}</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <Link to="/cuenta" data-testid="home-merchant-access-link" className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full bg-primary text-primary-foreground font-bold hover:shadow-[0_0_24px_rgba(15,232,20,0.35)] active:scale-95 transition-[box-shadow,transform]">
            {t("home.merchantAccess")} <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/registro" data-testid="home-register-link" className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full border border-primary/60 text-[hsl(122,87%,28%)] dark:text-primary font-bold hover:bg-primary/10 active:scale-95 transition-colors">
            {t("home.register")}
          </Link>
          <Link to="/docs" data-testid="home-docs-link" className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full border border-border font-semibold hover:bg-secondary active:scale-95 transition-colors">
            <BookOpen className="w-4 h-4" /> {t("home.docs")}
          </Link>
        </div>
        <div className="mt-12">
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">{t("home.methods")}</p>
          <div className="flex items-center gap-4 flex-wrap">
            {["logo_visa", "logo_mastercard", "logo_yappy"].map((l) => (
              <img key={l} src={`/logos/${l}.png`} alt={l} className="h-8 rounded bg-white px-2 py-1 object-contain border border-border" />
            ))}
          </div>
        </div>
      </main>
      <footer className="px-5 sm:px-10 py-6 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <span className="text-xs text-muted-foreground">{t("home.processedBy")}</span>
        <div className="flex items-center gap-3">
          <img src="/logos/sec_pci.png" alt="PCI DSS" className="h-7 object-contain" />
          <img src="/logos/sec_visa_secure.png" alt="Visa Secure" className="h-7 object-contain" />
          <img src="/logos/sec_mastercard.png" alt="Mastercard ID Check" className="h-7 object-contain" />
        </div>
      </footer>
    </div>
  );
}
